//データ様式
export enum EDataFormat {
  IROHANA_STANDARD = "IROHANA_STANDARD",
}

export const dataFormatOptions = [{ value: EDataFormat.IROHANA_STANDARD, label: "irohana標準" }];

//先頭行の仕様
export enum EFirstRowSpecification {
  JAPANESE_NAME = "JAPANESE_NAME",
  NONE = "NONE",
}

export const firstRowSpecificationOptions = [
  { value: EFirstRowSpecification.JAPANESE_NAME, label: "項目名" },
  { value: EFirstRowSpecification.NONE, label: "なし" },
];

//文字コード
export enum ECharacterCode {
  AUTO_DETECT = "AUTO_DETECT",
  SHIFT_JIS = "SHIFT_JIS",
  UTF8_UNICODE = "UTF8_UNICODE",
  UTF8_UNICODE_WITH_BOM = "UTF8_UNICODE_WITH_BOM",
}

export const characterCodeOptions = [
  { value: ECharacterCode.AUTO_DETECT, label: "自動認識" },
  { value: ECharacterCode.SHIFT_JIS, label: "Shift-JIS" },
  { value: ECharacterCode.UTF8_UNICODE, label: "UTF-8 / Unicode" },
  { value: ECharacterCode.UTF8_UNICODE_WITH_BOM, label: "UTF-8 / Unicode (BOM付き)" },
];

//区切り文字
export enum EDelimiter {
  COMMA = "COMMA",
  TAB_CHARACTER = "TAB_CHARACTER",
}

export const delimiterOptions = [
  { value: EDelimiter.COMMA, label: "カンマ" },
  { value: EDelimiter.TAB_CHARACTER, label: "タブ文字" },
];
